import { Injectable } from '@angular/core';
import { ColumnApi } from 'ag-grid-community';

@Injectable()
export default class AgGridUtils {
    constructor() { }

    static initialize() {
    }

    static showColumn(isShow: boolean, columnApi: ColumnApi, columnName: string): void {
        if (columnApi) columnApi.setColumnVisible(columnName, isShow);
    }

    static hideColumn(columnApi: ColumnApi, columnName: string): void {
        this.showColumn(false, columnApi, columnName);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/utilities/ag-grid.utils.ts